import { render, staticRenderFns } from "./DeliveryShopSelect.vue?vue&type=template&id=f8b891ea&scoped=true"
import script from "./DeliveryShopSelect.vue?vue&type=script&lang=js"
export * from "./DeliveryShopSelect.vue?vue&type=script&lang=js"
import style0 from "./DeliveryShopSelect.vue?vue&type=style&index=0&id=f8b891ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b891ea",
  null
  
)

export default component.exports